import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const menuSelectedTeam = atom({
  key: 'menuSelectedTeam',
  default: [],
  effects_UNSTABLE: [persistAtom],
})

/** 선택된 스튜디오(팀 상위) - standalone schedule에서 사용 */
export const menuSelectedStudio = atom({
  key: 'menuSelectedStudio',
  default: null,
  effects_UNSTABLE: [persistAtom],
})

export const isAopsChiefState = atom({
  key: 'isAopsChiefState',
  default: false,
  effects_UNSTABLE: [persistAtom],
})
